import { Card as CardComponent } from '@mantine/core'

import classNames from './card.module.css'

export const Card = CardComponent.extend({
  classNames,
})
